<template>
  <div id="my-nav" style="padding-bottom:20px;">
    <Button
      size="small"
      @click="goto({ name: 'xccass', params: { code: $route.params.code } })"
      :type="$route.name == 'xccass' ? 'primary' : 'default'"
      >个股经纪商持股查询</Button
    >
    <Button
      size="small"
      @click="goto({ name: 'changes', params: { cid: $route.params.code } })"
      :type="$route.name == 'changes' ? 'primary' : 'default'"
      >个股经纪商持股变动查询</Button
    >
    <Button
      size="small"
      @click="
        goto({ name: 'concentration', params: { cid: $route.params.code } })
      "
      :type="$route.name == 'concentration' ? 'primary' : 'default'"
      >个股经纪商持股集中度查询</Button
    >
    <Button
      size="small"
      v-show="$route.name == 'detail'"
      :type="$route.name == 'detail' ? 'primary' : 'default'"
      >个股单经纪商持股变动趋势查询</Button
    >
  </div>
</template>

<style>
#my-nav a {
  text-decoration: none;
}
</style>
<script>
export default {
  methods: {
    goto(target) {
      this.$router.push(target);
    }
  }
};
</script>
